module.exports = __webpack_public_path__ + "static/Logo-a945418e9a7a35886935c755341f46ac.png";